import WordHighlighter from "vue-word-highlighter";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('WordHighlighter', WordHighlighter);
})